module.exports = __webpack_public_path__ + "img/my-jabrutouch.42fc4628.svg";